<script setup>
import { onMounted, computed, watch } from 'vue'
import {useStore} from 'vuex'
import * as firebaseui from 'firebaseui'
import firebase from 'firebase/compat/app'
import 'firebaseui/dist/firebaseui.css'

const store = useStore()
const user = computed(() => store.getters.getUser)

const initFirebaseUI = () => {
  let ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth())
  ui.start('#firebaseui-auth-container', {
    signInFlow: 'popup',
    credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
    signInOptions: [
      {
        provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        customParameters: { prompt: 'select_account'}
      },
      {
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        signInMethod: firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD
      },
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID
      }
    ],
    callbacks: {
      signInSuccessWithAuthResult: function(authResult, redirectUrl) {
        // cleanup url params
        const url = new URL(window.location.href)
        url.searchParams.delete('mode')
        url.searchParams.delete('oobCode')
        window.history.replaceState({}, document.title, url.pathname)
      },
      signInFailure: async (error) => {
        console.warn("[login-window] ERROR" + error);
      },
    }
  })
}

const destroyFirebaseUI = () => {
  let ui = firebaseui.auth.AuthUI.getInstance()
  if (ui) {
    ui.delete()
  }
}

onMounted(() => {
  initFirebaseUI()
})

watch(user, () => {
  destroyFirebaseUI()
  initFirebaseUI()
})
</script>

<template>
  <div v-show="!user" class="md:p-1 xl:w-[1280px]">
    <div class="lg:flex items-center">
      <div class="lg:basis-2/3 mb-5 lg:mb-0">
        <img src="@/assets/img/earth-art.png" alt="Earth" class="md:max-w-full">
      </div>
      <div class="lg:basis-1/3 flex flex-col items-center justify-center ml-4">
        <div class="mb-4 text-center">
          <h1 class="font-black text-xl lg:text-3xl">Welcome to Earth</h1>
          <p class="text-gray-500">Sign in or create an account</p>
        </div>

        <div class="flex flex-col items-center justify-center">
          <div id="firebaseui-auth-container"></div>
        </div>
      </div>
    </div>
  </div>
  <div v-show="user" class="basis-1/3 flex flex-col items-center justify-center">
    <router-view></router-view>
  </div>
</template>

<style>
.firebaseui-card-content {
  padding: 0 !important;
}

.firebaseui-container {
  margin-top: 0 !important;
}

.firebaseui-dialog {
  pointer-events: auto !important;
}

.mdl-shadow--2dp {
  box-shadow: none !important;
}
</style>
